/* A labelled band in the drawer: label, hairline rule, then the actions
   that belong to that band. */
export function Section({ label, actions, children }) {
  return (
    <section className="sec">
      <div className="sechead">
        <span className="label">{label}</span>
        <span className="rule" />
        <span className="acts">{actions}</span>
      </div>
      {children}
    </section>
  );
}

/* The two-or-three-way pickers in the drawer (health, cadence). */
export function Segmented({ options, value, onPick, tone = "" }) {
  return (
    <span className={"seg " + tone}>
      {options.map(([key, label]) => (
        <button
          key={key}
          type="button"
          aria-pressed={key === value}
          onClick={() => onPick(key)}
        >
          {label}
        </button>
      ))}
    </span>
  );
}
